export default "__VITE_ASSET__BJNHGTpS__"